/**
 * @generated SignedSource<<0aca08a5d97f80d2880f2f00ac7daa2e>>
 * @relayHash cec4d21171e93675609fbb1aa29c2663
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cec4d21171e93675609fbb1aa29c2663

import { ConcreteRequest } from 'relay-runtime';
export type Country = "CH" | "DE";
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type SkillSpecialty = "CARDIOLOGY" | "DERMATOLOGY" | "GENERAL_INTERNAL_MEDICINE" | "GYNAECOLOGY" | "LONG_COVID" | "OTORHINOLARYNGOLOGY" | "PEDIATRICS" | "RHEUMATOLOGY" | "SPORTS_MEDICINE" | "STUDY" | "SURGERY" | "TELE_GENERAL_PRACTITIONER" | "UROLOGY" | "VACCINATION_ADVICE";
export type Team = "DERMATOLOGY" | "PEDIATRICS" | "PSYCHOSOCIAL";
export type useAgentSkillsQuery$variables = Record<PropertyKey, never>;
export type useAgentSkillsQuery$data = {
  readonly doctors: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly gender: Gender;
        readonly id: string;
        readonly languages: ReadonlyArray<{
          readonly fullySpottable: boolean;
          readonly skill: Language | null;
        }>;
        readonly licensesInCountries: ReadonlyArray<{
          readonly country: Country;
          readonly isFavoredInCountry: boolean;
        }>;
        readonly performancePerSlot: number;
        readonly preferredLanguage: Language;
        readonly specialties: ReadonlyArray<{
          readonly fullySpottable: boolean;
          readonly skill: SkillSpecialty | null;
        }>;
        readonly teams: ReadonlyArray<{
          readonly fullySpottable: boolean;
          readonly skill: Team | null;
        }>;
        readonly userName: string;
      };
    }> | null;
  } | null;
};
export type useAgentSkillsQuery = {
  response: useAgentSkillsQuery$data;
  variables: useAgentSkillsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fullySpottable",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skill",
    "storageKey": null
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "DoctorsConnection",
    "kind": "LinkedField",
    "name": "doctors",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DoctorsEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Doctor",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gender",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "performancePerSlot",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "preferredLanguage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LanguageSkillInformation",
                "kind": "LinkedField",
                "name": "languages",
                "plural": true,
                "selections": (v0/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SkillSpecialtySkillInformation",
                "kind": "LinkedField",
                "name": "specialties",
                "plural": true,
                "selections": (v0/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LicenseInformation",
                "kind": "LinkedField",
                "name": "licensesInCountries",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "country",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isFavoredInCountry",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamSkillInformation",
                "kind": "LinkedField",
                "name": "teams",
                "plural": true,
                "selections": (v0/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useAgentSkillsQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useAgentSkillsQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "cec4d21171e93675609fbb1aa29c2663",
    "metadata": {},
    "name": "useAgentSkillsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "96edbd45eb7ff9669e28013ab7efea2e";

export default node;
